import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutPricingComparison = {
  factory: EElement({
    id: '39403601-2421-2c54-992a-2fef1e746e29',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('01e5d4b1-00fb-fe2e-145e-14163813cbcd')]),
      children: EList([
        EElement({
          id: '39403601-2421-2c54-992a-2fef1e746e2a',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '654bbbdd-a9a8-77aa-d3b1-82056236e0d0',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('fa70bfbf-4f07-d263-6337-1587319b7484'),
                  ]),
                  children: EList([
                    EElement({
                      id: '927562d1-96ad-c0cd-158f-7df0c9f31b1c',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('dfce7811-35d9-6519-ad14-3a360128931c'),
                        ]),
                        children: EList([
                          EElement({
                            id: '1ef0e47c-272b-08ef-c9bb-6d735f00c74b',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageHills),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"62737680f2b1acddfc94b2e6"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('6a135e2f-ce26-a9d6-d3a3-36af6d58d4b6'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: 'ea1c2a3f-83b1-cf8a-c103-250f349b6687',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h2'),
                              styleBlockIds: EList([
                                EText('cdc80708-85ef-fa33-05ac-08b095d16812'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'ea1c2a3f-83b1-cf8a-c103-250f349b6688',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Startup'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '3fbe5e2d-8c52-c2bb-8453-ed526175142b',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('750ff23c-202d-7325-7274-18d452b968bd'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '3fbe5e2d-8c52-c2bb-8453-ed526175142c',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Starting at'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '15ae2e68-8183-5dde-2c90-b73cb1652ab0',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('d4180cfd-af2d-d339-91e4-4fc1610a4eea'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '15ae2e68-8183-5dde-2c90-b73cb1652ab1',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('$599/mo'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '4a500189-a153-ebd3-b776-52ff9b3bb5a0',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('085accec-0d5f-df37-a3d3-3032e92178d9'),
                                EText('ce0da178-963c-a8e2-1012-03d35278c4fd'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '4a500189-a153-ebd3-b776-52ff9b3bb5a1',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Lorem ipsum dolor'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '65e52a8e-03f1-5562-b294-35956edfb88a',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(true),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('5811e2db-f107-fb36-bedc-ae019c696e30'),
                                EText('7a50e611-1678-13fa-5f6c-0c95173beacf'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '65e52a8e-03f1-5562-b294-35956edfb88b',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Talk to an Expert'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '9691cfcf-3ea2-6aec-acdf-d75f7644c1e9',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('5563b8da-b02d-11bf-29c8-6545801686cf'),
                              ]),
                              children: EList([]),
                            }),
                          }),
                          EElement({
                            id: 'e3919366-e72f-7dda-a4ff-cc4902f41421',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('List')
                            ),
                            data: ERecord({
                              tag: EEnum('ul'),
                              list: ERecord({
                                type: EText('list'),
                                unstyled: EBoolean(true),
                              }),
                              styleBlockIds: EList([
                                EText('9e19e97f-ef18-dd24-7662-61a69125ecfc'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'e3919366-e72f-7dda-a4ff-cc4902f41422',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: 'f26c4273-8731-21cc-a9ed-305b75d94a6b',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'f26c4273-8731-21cc-a9ed-305b75d94a6c',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'e3919366-e72f-7dda-a4ff-cc4902f41423',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: 'e571cc25-fc1d-d55b-5b44-44125124618c',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'e571cc25-fc1d-d55b-5b44-44125124618d',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'e3919366-e72f-7dda-a4ff-cc4902f41424',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: 'f6a5950a-b8da-3add-ac7d-619602dc7ff5',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'f6a5950a-b8da-3add-ac7d-619602dc7ff6',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '4e6cd9b1-8311-8f1d-9edb-679247d8e4d7',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: 'fd7fbb3b-ac18-1b29-77f3-5190f18d1f05',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'fd7fbb3b-ac18-1b29-77f3-5190f18d1f06',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '4e9ff71b-8019-ad65-58fb-a32e0380ce2f',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: 'bde2d19d-2b3a-56b5-af3c-9fd7336f0bb6',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'bde2d19d-2b3a-56b5-af3c-9fd7336f0bb7',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '65ee34ed-ab58-6eef-4234-8bf8dd14224f',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: 'fc949f52-991a-526b-0cc1-fc0906460cd7',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'fc949f52-991a-526b-0cc1-fc0906460cd8',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'd9dd2f4c-4aaa-a864-7872-158783455366',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('dfce7811-35d9-6519-ad14-3a360128931c'),
                          EText('58ca077f-54fd-e5b6-6a22-2e1afdc5eb75'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'd9dd2f4c-4aaa-a864-7872-158783455367',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageOverlap),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"62737680f2b1acddfc94b306"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('6a135e2f-ce26-a9d6-d3a3-36af6d58d4b6'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: 'd9dd2f4c-4aaa-a864-7872-158783455368',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h2'),
                              styleBlockIds: EList([
                                EText('cdc80708-85ef-fa33-05ac-08b095d16812'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd9dd2f4c-4aaa-a864-7872-158783455369',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Growth'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'd9dd2f4c-4aaa-a864-7872-15878345536a',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('750ff23c-202d-7325-7274-18d452b968bd'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd9dd2f4c-4aaa-a864-7872-15878345536b',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Starting at'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'd9dd2f4c-4aaa-a864-7872-15878345536c',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('d4180cfd-af2d-d339-91e4-4fc1610a4eea'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd9dd2f4c-4aaa-a864-7872-15878345536d',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('$1,499/mo'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'd9dd2f4c-4aaa-a864-7872-15878345536e',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('085accec-0d5f-df37-a3d3-3032e92178d9'),
                                EText('ce0da178-963c-a8e2-1012-03d35278c4fd'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd9dd2f4c-4aaa-a864-7872-15878345536f',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Lorem ipsum dolor'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'd9dd2f4c-4aaa-a864-7872-158783455370',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(true),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('5811e2db-f107-fb36-bedc-ae019c696e30'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd9dd2f4c-4aaa-a864-7872-158783455371',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Talk to an Expert'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'd9dd2f4c-4aaa-a864-7872-158783455372',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('5563b8da-b02d-11bf-29c8-6545801686cf'),
                              ]),
                              children: EList([]),
                            }),
                          }),
                          EElement({
                            id: '1eba283d-7abe-afed-16b3-5a5b78859fe1',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('List')
                            ),
                            data: ERecord({
                              tag: EEnum('ul'),
                              list: ERecord({
                                type: EText('list'),
                                unstyled: EBoolean(true),
                              }),
                              styleBlockIds: EList([
                                EText('9e19e97f-ef18-dd24-7662-61a69125ecfc'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '1eba283d-7abe-afed-16b3-5a5b78859fe2',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '1eba283d-7abe-afed-16b3-5a5b78859fe3',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '1eba283d-7abe-afed-16b3-5a5b78859fe4',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Etiam sodales ac felis id interdum'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '1eba283d-7abe-afed-16b3-5a5b78859fe5',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '1eba283d-7abe-afed-16b3-5a5b78859fe6',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '1eba283d-7abe-afed-16b3-5a5b78859fe7',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Etiam sodales ac felis id interdum'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '1eba283d-7abe-afed-16b3-5a5b78859fe8',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '1eba283d-7abe-afed-16b3-5a5b78859fe9',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '1eba283d-7abe-afed-16b3-5a5b78859fea',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Etiam sodales ac felis id interdum'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '1eba283d-7abe-afed-16b3-5a5b78859feb',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '1eba283d-7abe-afed-16b3-5a5b78859fec',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '1eba283d-7abe-afed-16b3-5a5b78859fed',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Etiam sodales ac felis id interdum'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '1eba283d-7abe-afed-16b3-5a5b78859fee',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '1eba283d-7abe-afed-16b3-5a5b78859fef',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '1eba283d-7abe-afed-16b3-5a5b78859ff0',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Etiam sodales ac felis id interdum'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '1eba283d-7abe-afed-16b3-5a5b78859ff1',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '1eba283d-7abe-afed-16b3-5a5b78859ff2',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '1eba283d-7abe-afed-16b3-5a5b78859ff3',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Etiam sodales ac felis id interdum'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '2f98aa2b-3c0c-512c-2a72-bf8bb1a10a07',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '2f98aa2b-3c0c-512c-2a72-bf8bb1a10a08',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '2f98aa2b-3c0c-512c-2a72-bf8bb1a10a09',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Etiam sodales ac felis id interdum'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'f56fe916-482c-f38c-8a07-5cbb66725dce',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: 'f56fe916-482c-f38c-8a07-5cbb66725dcf',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'f56fe916-482c-f38c-8a07-5cbb66725dd0',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Etiam sodales ac felis id interdum'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '0a7acd9d-5911-7534-50d2-65d3a4790519',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('ebda7fa6-d302-d3c6-95e7-9104dd276c58'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '0a7acd9d-5911-7534-50d2-65d3a479051a',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Recommended'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '100f15ab-6cb0-baf0-60a1-731f14c35469',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('dfce7811-35d9-6519-ad14-3a360128931c'),
                        ]),
                        children: EList([
                          EElement({
                            id: '100f15ab-6cb0-baf0-60a1-731f14c3546a',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageGallery),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"62737680f2b1acddfc94b2e9"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('6a135e2f-ce26-a9d6-d3a3-36af6d58d4b6'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '100f15ab-6cb0-baf0-60a1-731f14c3546b',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h2'),
                              styleBlockIds: EList([
                                EText('cdc80708-85ef-fa33-05ac-08b095d16812'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '100f15ab-6cb0-baf0-60a1-731f14c3546c',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Enterprise'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '100f15ab-6cb0-baf0-60a1-731f14c3546d',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('750ff23c-202d-7325-7274-18d452b968bd'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '100f15ab-6cb0-baf0-60a1-731f14c3546e',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Starting at'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '100f15ab-6cb0-baf0-60a1-731f14c3546f',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('d4180cfd-af2d-d339-91e4-4fc1610a4eea'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '100f15ab-6cb0-baf0-60a1-731f14c35470',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('$2,499/mo'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '100f15ab-6cb0-baf0-60a1-731f14c35471',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('085accec-0d5f-df37-a3d3-3032e92178d9'),
                                EText('ce0da178-963c-a8e2-1012-03d35278c4fd'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '100f15ab-6cb0-baf0-60a1-731f14c35472',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Lorem ipsum dolor'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '2f98acea-81e6-ab30-0d55-118b7e6b4584',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(true),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('5811e2db-f107-fb36-bedc-ae019c696e30'),
                                EText('7a50e611-1678-13fa-5f6c-0c95173beacf'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '2f98acea-81e6-ab30-0d55-118b7e6b4585',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Talk to an Expert'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '100f15ab-6cb0-baf0-60a1-731f14c35475',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('5563b8da-b02d-11bf-29c8-6545801686cf'),
                              ]),
                              children: EList([]),
                            }),
                          }),
                          EElement({
                            id: '043d1353-c67c-64b2-b5e3-21d10d6d71d5',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('List')
                            ),
                            data: ERecord({
                              tag: EEnum('ul'),
                              list: ERecord({
                                type: EText('list'),
                                unstyled: EBoolean(true),
                              }),
                              styleBlockIds: EList([
                                EText('9e19e97f-ef18-dd24-7662-61a69125ecfc'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '043d1353-c67c-64b2-b5e3-21d10d6d71d6',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '043d1353-c67c-64b2-b5e3-21d10d6d71d7',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '043d1353-c67c-64b2-b5e3-21d10d6d71d8',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '043d1353-c67c-64b2-b5e3-21d10d6d71d9',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '043d1353-c67c-64b2-b5e3-21d10d6d71da',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '043d1353-c67c-64b2-b5e3-21d10d6d71db',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '043d1353-c67c-64b2-b5e3-21d10d6d71dc',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '043d1353-c67c-64b2-b5e3-21d10d6d71dd',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '043d1353-c67c-64b2-b5e3-21d10d6d71de',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '043d1353-c67c-64b2-b5e3-21d10d6d71df',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '043d1353-c67c-64b2-b5e3-21d10d6d71e0',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '043d1353-c67c-64b2-b5e3-21d10d6d71e1',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '043d1353-c67c-64b2-b5e3-21d10d6d71e2',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '043d1353-c67c-64b2-b5e3-21d10d6d71e3',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '043d1353-c67c-64b2-b5e3-21d10d6d71e4',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '043d1353-c67c-64b2-b5e3-21d10d6d71e5',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('ListItem')
                                  ),
                                  data: ERecord({
                                    list: ERecord({
                                      type: EText('item'),
                                    }),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '043d1353-c67c-64b2-b5e3-21d10d6d71e6',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(true),
                                          styleBlockIds: EList([
                                            EText(
                                              'd3f17a54-29ef-025d-3257-9467f4ee674d'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '043d1353-c67c-64b2-b5e3-21d10d6d71e7',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '01e5d4b1-00fb-fe2e-145e-14163813cbcd',
      type: 'class',
      name: 'Pricing Comparison',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: 'fa70bfbf-4f07-d263-6337-1587319b7484',
      type: 'class',
      name: 'Pricing Wrapper',
      comb: '',
      styleLess:
        'display: grid; align-items: center; grid-auto-columns: 1fr; grid-column-gap: 40px; grid-row-gap: 50px; grid-template-columns: 1fr 1fr 1fr; grid-template-rows: auto;',
      children: [],
      variants: {
        medium: {
          styleLess: 'justify-items: center; grid-template-columns: 1fr;',
        },
        small: {styleLess: 'justify-items: stretch;'},
      },
    },
    {
      _id: 'dfce7811-35d9-6519-ad14-3a360128931c',
      type: 'class',
      name: 'Pricing Card',
      comb: '',
      styleLess:
        'position: relative; display: flex; padding-top: 32px; padding-right: 24px; padding-bottom: 32px; padding-left: 24px; flex-direction: column; justify-content: flex-start; align-items: center; background-color: hsla(0, 0.00%, 100.00%, 1.00); box-shadow: 0 4px 130px 0 hsla(214.83870967741936, 17.32%, 64.90%, 0.12);',
      children: ['58ca077f-54fd-e5b6-6a22-2e1afdc5eb75'],
      variants: {
        medium: {styleLess: 'width: 350px;'},
        small: {styleLess: 'width: auto;'},
      },
    },
    {
      _id: '6a135e2f-ce26-a9d6-d3a3-36af6d58d4b6',
      type: 'class',
      name: 'Pricing Image',
      comb: '',
      styleLess:
        'width: 80px; height: 80px; margin-bottom: 16px; object-fit: cover;',
      children: [],
      variants: {},
    },
    {
      _id: 'cdc80708-85ef-fa33-05ac-08b095d16812',
      type: 'class',
      name: 'Pricing Title',
      comb: '',
      styleLess:
        'margin-top: 10px; margin-bottom: 8px; font-size: 40px; line-height: 48px; font-weight: 500;',
      children: [],
      variants: {small: {styleLess: 'font-size: 34px; line-height: 42px;'}},
    },
    {
      _id: '750ff23c-202d-7325-7274-18d452b968bd',
      type: 'class',
      name: 'Pricing Subtitle',
      comb: '',
      styleLess: 'margin-bottom: 12px; font-size: 14px; line-height: 20px;',
      children: [],
      variants: {},
    },
    {
      _id: 'd4180cfd-af2d-d339-91e4-4fc1610a4eea',
      type: 'class',
      name: 'Pricing Price',
      comb: '',
      styleLess:
        'margin-bottom: 8px; font-size: 24px; line-height: 32px; font-weight: 700;',
      children: [],
      variants: {},
    },
    {
      _id: '085accec-0d5f-df37-a3d3-3032e92178d9',
      type: 'class',
      name: 'Paragraph Regular',
      comb: '',
      styleLess: 'font-size: 14px; line-height: 20px;',
      children: ['ce0da178-963c-a8e2-1012-03d35278c4fd'],
      variants: {},
    },
    {
      _id: 'ce0da178-963c-a8e2-1012-03d35278c4fd',
      type: 'class',
      name: 'Margin Bottom 20',
      comb: '&',
      styleLess: 'margin-bottom: 20px;',
      children: [],
      variants: {},
    },
    {
      _id: '5811e2db-f107-fb36-bedc-ae019c696e30',
      type: 'class',
      name: 'Button Primary',
      comb: '',
      styleLess:
        'padding-top: 12px; padding-right: 25px; padding-bottom: 12px; padding-left: 25px; background-color: #1a1b1f; transition-property: all; transition-duration: 200ms; transition-timing-function: ease; color: hsla(0, 0.00%, 100.00%, 1.00); font-size: 12px; line-height: 20px; letter-spacing: 2px; text-transform: uppercase;',
      children: [
        '7a50e611-1678-13fa-5f6c-0c95173beacf',
        '0333fb64-65a4-0eb3-2546-375483e0a446',
      ],
      variants: {
        main_hover: {
          styleLess:
            'background-color: #32343a; color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        main_active: {styleLess: 'background-color: #43464d;'},
      },
    },
    {
      _id: '7a50e611-1678-13fa-5f6c-0c95173beacf',
      type: 'class',
      name: 'Outline Button',
      comb: '&',
      styleLess:
        'background-color: transparent; box-shadow: inset 0 0 0 1px #1a1b1f; color: #1a1b1f;',
      children: [],
      variants: {
        main_hover: {
          styleLess:
            'background-color: #1a1b1f; color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
      },
    },
    {
      _id: '5563b8da-b02d-11bf-29c8-6545801686cf',
      type: 'class',
      name: 'Pricing Divider',
      comb: '',
      styleLess:
        'height: 1px; margin-top: 56px; margin-right: -24px; margin-bottom: 16px; margin-left: -24px; align-self: stretch; background-color: hsla(213.84615384615384, 16.60%, 53.92%, 0.10);',
      children: [],
      variants: {},
    },
    {
      _id: '9e19e97f-ef18-dd24-7662-61a69125ecfc',
      type: 'class',
      name: 'Pricing Feature List',
      comb: '',
      styleLess: 'align-self: stretch;',
      children: [],
      variants: {},
    },
    {
      _id: 'd3f17a54-29ef-025d-3257-9467f4ee674d',
      type: 'class',
      name: 'Pricing Feature',
      comb: '',
      styleLess: `margin-top: 16px; padding-left: 32px; align-self: stretch; background-image: url(${images.checkCircleDark}); background-position: 0% 0%; background-size: auto; background-repeat: no-repeat; font-size: 14px; line-height: 24px;`,
      children: [],
      variants: {},
    },
    {
      _id: '58ca077f-54fd-e5b6-6a22-2e1afdc5eb75',
      type: 'class',
      name: 'Featured Pricing',
      comb: '&',
      styleLess:
        'z-index: 2; box-shadow: 0 4px 130px 0 hsla(214.83870967741936, 17.32%, 64.90%, 0.30);',
      children: [],
      variants: {},
    },
    {
      _id: 'ebda7fa6-d302-d3c6-95e7-9104dd276c58',
      type: 'class',
      name: 'Pricing Tag',
      comb: '',
      styleLess:
        'position: absolute; top: -19px; padding-top: 7px; padding-right: 16px; padding-bottom: 7px; padding-left: 16px; border-top-left-radius: 24px; border-top-right-radius: 24px; border-bottom-left-radius: 24px; border-bottom-right-radius: 24px; background-color: white; box-shadow: 0 3px 10px 0 hsla(214.83870967741936, 17.32%, 64.90%, 0.20); color: hsla(214.6153846153846, 18.31%, 27.84%, 1.00);',
      children: [],
      variants: {},
    },
  ],
} as const;
